import { fabric } from 'fabric';
import ToolOption from '../common/ToolOption';
import { CanvasEventType, GraphType } from '../constants/Constants';
import log from 'loglevel';
import Graphic from './Graphic';
/**
 * 图片
 *
 * @export
 * @class CanvasBitmap
 * @extends {Graphic}
 */
export default class CanvasBitmap extends Graphic {
  constructor(app) {
    super(app);
  }

  addEvents() {
    super.addEvents();
    this.root.on(CanvasEventType.Add, o => {
      log.info('add', o);
      if (!o.target) {
        return;
      }
      let data = this.factory.createAddData(this.bitmap);
      // MsgSender.add(data)
      this.app.sender.add(data);
    });
  }

  removeEvents() {
    super.removeEvents();
    this.root.off(CanvasEventType.Add);
  }

  set option(val) {
    if (!val) {
      this._option = this.defaultOption;
      return;
    }

    if (!val.hasOwnProperty('url')) {
      log.error('Bitmap URL is null');
      return;
    }

    if (val.url === '') {
      return;
    }

    this.add(val.url);
  }

  get option() {
    return this._option;
  }

  get defaultOption() {
    let opt = new ToolOption();
    opt.url = '';
    return opt;
  }

  add(url) {
    let oo = this.app.items.originOption;
    let imgURLBase = oo.basic.imgBaseURL;
    if (imgURLBase === undefined || imgURLBase === '') {
      return;
    }

    const OFFSET = 20;
    let imgURL = imgURLBase + url;
    fabric.Image.fromURL(imgURL, img => {
      let iw = img.width;
      let ih = img.height;

      let showW = img.width;
      let showH = img.height;
      let ratio = 1;
      if (iw > this.app.stage.getStageWidth() - OFFSET * 2 || ih > this.app.stage.getStageHeight() - OFFSET * 2) {
        let ratioX = (this.app.stage.getStageWidth() - OFFSET * 2) / iw;
        let ratioY = (this.app.stage.getStageHeight() - OFFSET * 2) / ih;
        ratio = Math.min(ratioX, ratioY);
      }

      img
        .set({
          left: OFFSET,
          top: OFFSET
        })
        .scale(ratio);
      this.bitmap = img;
      this.root.add(img);
    });
  }

  static toAddData(target) {
    let obj = Graphic.toAddData(target);
    obj.gtype = GraphType.BITMAP;
    // 利用node.js url的parse返回一个url对象。 类似 window.location
    // obj.url = URL(target.getSrc()).pathname

    if (target._element) {
      const u = target._element.src; // http://abc.com/aaa/1.jpg
      obj.url = new URL(u).pathname;
    }

    return obj;
  }
}
